// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","links":"footer-module--links--2iHdD"};